export const getDuration = (src: string, cb: (n: number) => void) => {
  var audio = new Audio();
  audio.addEventListener('loadedmetadata', function () {
    cb(audio.duration);
  });
  audio.src = src;
};
